import {curry} from '../components/step2/context/SelectedVariantContext/helper'

export const filterList = curry((list, filterFn) => {
    return list.filter(filterFn)
})

export const addItemToList = curry((list, item) => {
    return [...list, item]
})

export const addItemsToList = curry((list, items) => {
    return [...list, ...items]
})

export const removeItemFromList = curry((list, itemId) => {
    return list.filter((i) => i.id !== itemId)
})
